import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { buildHttpParams } from 'src/app/helpers/build-state-params';
import { Crate } from 'src/models/Crate';

type CrateFilters = {
  state?: string | string[];
  groundPositionGroupId?: string;
  x?: number;
  y?: number;
};

@Injectable({
  providedIn: 'root'
})
export class V3CratesDataSourceService {
  private baseUrl = `${environment.v3BaseUrl}/api/v3/admin-desktop/pallets`;

  constructor(
    private http: HttpClient
  ) { }

  getAll(filters?: CrateFilters) {
    const params = buildHttpParams(filters);
    return this.http.get<Crate[]>(this.baseUrl, { params });
  }
} 